<h1 mat-dialog-title [ngStyle]="{ color: 'red', 'font-weight': '700' }">
  {{ data.title }}
</h1>
<div mat-dialog-content>{{ data.subtitle }}</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>Close</button>
</div>
